// ui_admin/src/api/index.js
import axios from "axios";

// 1. Create a variable to hold the store, but do NOT import it directly!
let store;

// 2. Create an injection function we can call from the main index.js
export const injectStore = (_store) => {
  store = _store;
};

export const dashAPI = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

dashAPI.interceptors.request.use(
  (config) => {
    if (store) {
      const state = store.getState();
      const token = state.user?.user?.token;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

dashAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized API call. Token may be expired.");
    }
    return Promise.reject(error);
  },
);
